import pathToRegExp from 'path-to-regexp';
import history from 'src/history';
import { get } from './deep';

const capitalToDashedLower = name => name.replace(/[^A-Z0-9]/ig, '').replace(/([a-zA-Z])(?=[A-Z])/g, '$1-').toLowerCase();

const prettifyString = (str) => {
  const words = str.match(/([^-]+)/g) || [];
  words.forEach((word, i) => {
    words[i] = word[0].toUpperCase() + word.slice(1);
  });
  return words.join(' ');
};

const getLocationParam = (path, index, decode = true) => {
  const pathname = history.location.pathname;
  const result = pathToRegExp(path).exec(pathname);
  const jobName = get(result, String(index), '');
  return decode ? decodeURIComponent(jobName) : jobName;
};

const checkPassword = value => /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,15}$/.test(value);
export const checkEmail = value => /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/.test(value);
const checkChactersLength = value => [...value].length >= 8 &&  [...value].length <= 15  ;
const checkLowerCase = value =>/^(?=.*[a-z]).+$/.test(value);
const checkNumber = value => /(?=.*\d)/.test(value);
const checkSpecialCharacter = value => value.match(/(?=.*[!@$%&*?]).+$/);
const checkUpperCase = value => /^(?=.*[A-Z]).+$/.test(value);
const checkUnwantedSpecialCharacters = value => value.match(/[^a-zA-Z0-9!@#$%&*?]/g);


export default { capitalToDashedLower };
export {
  capitalToDashedLower,
  getLocationParam,
  checkPassword,
  prettifyString,
};

export { checkChactersLength, checkLowerCase, checkNumber, checkSpecialCharacter, checkUpperCase, checkUnwantedSpecialCharacters };



// WEBPACK FOOTER //
// ./src/helpers/regex.js